import { render, staticRenderFns } from "./ListBiotecPlagas.vue?vue&type=template&id=36f2e72e&scoped=true"
import script from "./ListBiotecPlagas.vue?vue&type=script&lang=js"
export * from "./ListBiotecPlagas.vue?vue&type=script&lang=js"
import style0 from "./ListBiotecPlagas.vue?vue&type=style&index=0&id=36f2e72e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f2e72e",
  null
  
)

export default component.exports